<template>
  <div class="details-panel">
    <ZoomCenterTransition>
      <TriggerButton
        v-if="!showPanel"
        @click="showPanel = true"
        icon="graphic_eq"
      />
    </ZoomCenterTransition>
    <SlideXRightTransition>
      <div v-if="showPanel" class="panel smooth-shadow">
        <div class="panel-header smooth-shadow">
          <Spinner v-if="isRequestInProgress" small />
          <icon v-else size="18">graphic_eq</icon>
          <h3 class="mar-left-10">Analysis Details</h3>
          <expand />
          <icon type="button" size="18" @click="showPanel = false">clear</icon>
        </div>
        <simplebar class="panel-body-wrapper" data-auto-hide="true">
          <div class="panel-body">
            <DetailsCard
              v-for="layer in Object.values(getActiveLayerDetails)"
              :key="layer.id"
              :layer="layer"
            />
            <DistributionGrouped
              v-if="
                getDistributionSeries.combinedSeries &&
                  getDistributionSeries.combinedSeries['daily'] &&
                  getDistributionSeries.combinedSeries['weekly']
              "
              :combinedSeries="getDistributionSeries.combinedSeries"
              :categories="getDistributionSeries.categories"
            />
          </div>
        </simplebar>
      </div>
    </SlideXRightTransition>
  </div>
</template>

<script>
import { ZoomCenterTransition, SlideXRightTransition } from "vue2-transitions";
import TriggerButton from "@/components/static_entity_analysis/views/TriggerButton";
import { mapGetters } from "vuex";
import DetailsCard from "@/components/supply_demand_gap/views/DetailsCard";
import DistributionGrouped from "@/components/supply_demand_gap/views/DistributionGrouped";

export default {
  components: {
    ZoomCenterTransition,
    SlideXRightTransition,
    TriggerButton,
    DetailsCard,
    DistributionGrouped,
  },
  data() {
    return {
      showPanel: true,
    };
  },
  computed: {
    ...mapGetters("SupplyDemand", ["getDetailsWidget", "getDistributions"]),
    ...mapGetters("Data", ["isRequestInProgress"]),
    ...mapGetters("Layers", ["getActiveLayers", "getActiveLayerDetails"]),

    getDistributionSeries() {
      let combinedSeries = {};
      // {
      //   daily: [{ data: [] }, { data: [] }],
      //   weekly: [{ data: [] }, { data: [] }],
      // };
      let categories = {};
      // {
      //   daily: [1,2,3..],
      //   weekly: [MON, TUE, ...],
      // };

      Object.values(this.getActiveLayerDetails).forEach(layer => {
        let distributions = this.getDistributions(layer.id);
        if (!distributions) return;

        Object.keys(distributions).forEach(key => {
          // [["FRI",322], ["MON": 23]]
          let category = [];
          let series = [];

          distributions[key].forEach(pair => {
            if (pair[0] !== null) {
              category.push(pair[0]);
              series.push(pair[1]);
            }
          });

          if (key && combinedSeries && combinedSeries[key]) {
            combinedSeries[key].push({ data: series, name: layer.name });
          } else {
            combinedSeries[key] = [{ data: series, name: layer.name }];
            categories[key] = category;
          }
        });
      });

      // console.log({ combinedSeries });
      // console.log({ categories });
      return { combinedSeries, categories };
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.details-panel {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 99;

  .trigger-button {
    padding: 10px;
    background: var(--color-secondary);
    border-radius: 50%;
    transition: 0.1s all ease-in-out;

    &:hover {
      color: var(--color-primary);
      cursor: pointer;
    }

    &:active {
      transform: scale(0.9);
    }
  }

  .panel {
    width: 300px;
    height: 55vh;
    background: var(--color-default-background);
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    border-radius: 5px;

    .panel-header {
      display: flex;
      flex-direction: row;
      align-items: center;
      border-radius: 5px 5px 0 0;
      background: var(--color-secondary);
      padding: 7px 5px 7px 15px;

      .header-texts {
        display: flex;
        flex: 1;
      }
    }

    .panel-body-wrapper {
      /* THIS WORKS: */
      flex: 1;
      min-height: 5px;

      .panel-body {
        /* overflow: auto; */

        .no-content-image {
          display: flex;
          flex-direction: column;
          padding: 15px;
          justify-content: center;
          align-items: center;

          .image {
            height: 200px;
            width: auto;
          }
          p {
            margin: 0;
            opacity: 0.7;
            margin-top: 20px;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
